/**
 * Cross-package constants shared by `@aris/api` and `@aris/web`.
 *
 * Background (Wave 5 fix-pack 5.x.1, devil-advocate F1/F2 — production-fatal):
 * Prior to this module the FE hard-coded the literal `'X-CSRF'` while the BE
 * read `'x-csrf-token'`. Silent-refresh therefore only worked because the
 * happy-path tests on FE used the same wrong literal that production code
 * used. Centralising the values here makes header-name drift a compile-time
 * impossibility — both sides import from the same source of truth.
 *
 * NOTE: header names are matched case-insensitively by HTTP, but Express
 * lowercases incoming header names, so cookies.ts compares against the
 * lowercase form. We pick the lowercase canonical here for consistency.
 */
export const CSRF_HEADER_NAME = 'x-csrf-token';
export const CSRF_COOKIE_NAME = 'aris_csrf';
export const REFRESH_COOKIE_NAME = 'aris_refresh';
